"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestResultsError = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var FlatButton_1 = __importStar(require("@atg/icf-react-components/components/FlatButton"));
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var react_jss_1 = __importDefault(require("react-jss"));
var ContestResultsErrorLayout = (0, react_jss_1.default)({
    contestResultsErrorLayout: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        height: "100%",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.contestResultsErrorLayout }, props));
});
var ContestResultsErrorTitle = (0, react_jss_1.default)(function (theme) { return ({
    contestResultsErrorTitle: {
        fontSize: theme.spacing.base * 3,
        fontWeight: "bold",
        padding: theme.spacing.base * 1.75,
        textAlign: "center",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.contestResultsErrorTitle }, props));
});
var ContestResultsErrorMessage = (0, react_jss_1.default)(function (theme) { return ({
    contestResultsErrorMessage: {
        fontSize: theme.spacing.base * 2,
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.contestResultsErrorMessage }, props));
});
var ContestResultsErrorButtons = (0, react_jss_1.default)(function (theme) { return ({
    contestResultsErrorButtons: {
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing.base * 2.25,
        justifyContent: "center",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.contestResultsErrorButtons }, props));
});
var TryAgainButtonContainer = (0, react_jss_1.default)({
    tryAgainButtonContainer: {
        height: "100%",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.tryAgainButtonContainer }, props));
});
var BackToLiveButtonContainer = (0, react_jss_1.default)(function (theme) { return ({
    backToLiveButtonContainer: {
        height: "100%",
        marginTop: theme.spacing.base * 2,
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.backToLiveButtonContainer }, props));
});
var ContestResultsError = /** @class */ (function (_super) {
    __extends(ContestResultsError, _super);
    function ContestResultsError(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleBackToLiveClick = _this.handleBackToLiveClick.bind(_this);
        return _this;
    }
    ContestResultsError.prototype.handleBackToLiveClick = function () {
        window.location.href = "/browse/livesex/allcams";
    };
    ContestResultsError.prototype.render = function () {
        var _a = this.props, onTryAgainClicked = _a.onTryAgainClicked, translate = _a.translate;
        return (React.createElement(ContestResultsErrorLayout, null,
            React.createElement("div", null,
                React.createElement(ContestResultsErrorTitle, null, translate("contest.error_title")),
                React.createElement(ContestResultsErrorMessage, null, translate("contest.error_message_1")),
                React.createElement(ContestResultsErrorMessage, null, translate("contest.error_message_2")),
                React.createElement(ContestResultsErrorButtons, null,
                    React.createElement(TryAgainButtonContainer, null,
                        React.createElement(RaisedButton_1.default, { "data-ta-locator": "ContestResultsErrorRefreshButton", label: translate("contest.refresh"), onClick: onTryAgainClicked, size: "large", fullWidth: true })),
                    React.createElement(BackToLiveButtonContainer, null,
                        React.createElement(FlatButton_1.default, { "data-ta-locator": "ContestResultsErrorBackToLiveButton", label: translate("search.back_to_allcams"), onClick: this.handleBackToLiveClick, size: FlatButton_1.FlatButtonSizes.LARGE, ghost: true, fullWidth: true }))))));
    };
    return ContestResultsError;
}(React.Component));
exports.ContestResultsError = ContestResultsError;
//# sourceMappingURL=ContestResultsError.js.map